export function sortValues(values: any[], property: string, order: 'asc' | 'desc'): any[] {
  if (order === 'asc') {
    return values.sort((a, b) => {
      return a[property] - b[property];
    });
  } else {
    return values.sort((a, b) => {
      return b[property] - a[property];
    });
  }
}
